import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { useQuery, useLazyQuery } from "@apollo/client";
import { downloadExcel, downloadPDF } from "../../../utils/generalUtils";

import Structure from "../../../components/Base/Structure";

import Filter from "./Filter";
import ReportResult from "./ReportResult";

import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

import PageTitle from "../../../components/Base/PageTitle";

import ASSETS_BYGROUPS_QUERY from "../../../graphql/queries/assetByGroupsQuery";
import TRACKING_BOARD_QUERY from "../../../graphql/queries/getTrackingBoardReportQuery";
import TRACKING_BOARD_EXPORT_QUERY from "../../../graphql/queries/getTrackingBoardReportExportQuery";
import { useFilterValidation } from "../useFilterValidation";

import { useTranslation } from "../../../lang";
import { localDateTimeStringToUTC } from "../../../utils/dates";

const TrackingBoardReport = ({ selectedGroups }) => {
  const [t] = useTranslation();
  const [assetList, setAssetList] = useState([]);
  const [exportSelected, setExportSelected] = useState("EXCEL");
  const [assetTableState] = useState({
    searchText: "",
    sort: undefined,
    paginate: false,
  });
  const [resultState, setResultState] = useState({
    isOpen: false,
    type: "success",
    msg: "",
  });
  const [reportResult, setReportResult] = useState([]);

  const {} = useQuery(ASSETS_BYGROUPS_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      groupIDs: selectedGroups.filter(
        (g) => g && !Number.isNaN(Number.parseInt(g))
      ),
      ...assetTableState,
    },
    onCompleted(d) {
      const { count, items } = d.assetsByGroups;
      //setTotal(count);
      setAssetList(items.map((a) => ({
        ...a,
        completeName: `${a.name} - ${a.licensePlate}`
      })));
    },
  });

  const [fetchReport] = useLazyQuery(TRACKING_BOARD_QUERY, {
    fetchPolicy: "network-only",
    onCompleted(d) {
      if (d.trackingBoardReport) setReportResult(d.trackingBoardReport);
      else {
        setReportResult(null);
        setResultState({
          isOpen: true,
          type: "info",
          msg: t("No se encontraron datos para su consulta"),
        });
      }
    },
    onError(err) {
      setResultState({
        isOpen: true,
        type: "error",
        msg: err.message,
      });
    },
  });

  const [getExport] = useLazyQuery(TRACKING_BOARD_EXPORT_QUERY, {
    fetchPolicy: "network-only",
    onCompleted(d) {
      const filename = t("ReporteTableroSeguimiento");
      switch (exportSelected) {
        case "EXCEL":
          downloadExcel(d.trackingBoardReportExport, filename);
          break;
        case "PDF":
          downloadPDF(d.trackingBoardReportExport, filename);
          break;
      }
    },
  });

  const handleSearchReportTrackingBoard = ({
    assetsSelected,
    fechaInicio,
    fechaFin,
    days,
  }) => {
    fetchReport({
      variables: {
        assetsSelected,
        fechaInicio: localDateTimeStringToUTC(fechaInicio),
        fechaFin: localDateTimeStringToUTC(fechaFin),
        days,
      },
    });
  };

  const { handleSearchReport, errors: filterErrors } = useFilterValidation(
    handleSearchReportTrackingBoard
  );

  const handleExportExcel = (assetsSelected, fechaInicio, fechaFin, days) => {
    setExportSelected("EXCEL");
    getExport({
      variables: {
        assetsSelected,
        fechaInicio: localDateTimeStringToUTC(fechaInicio),
        fechaFin: localDateTimeStringToUTC(fechaFin),
        days,
        format: "EXCEL",
      },
    });
  };

  const handleExportPDF = (assetsSelected, fechaInicio, fechaFin, days) => {
    setExportSelected("PDF");
    getExport({
      variables: {
        assetsSelected,
        fechaInicio: localDateTimeStringToUTC(fechaInicio),
        fechaFin: localDateTimeStringToUTC(fechaFin),
        days,
        format: "PDF",
      },
    });
  };

  const handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setResultState({
      ...resultState,
      isOpen: false,
    });
  };

  return (
    <Structure>
      <Snackbar
        open={resultState.isOpen}
        autoHideDuration={5000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseNotification}
          severity={resultState.type}
          variant="filled"
        >
          {resultState.msg}
        </MuiAlert>
      </Snackbar>
      <PageTitle
        sector={t("Estadísticas")}
        title={t("Tablero de Seguimiento")}
      />
      <Filter
        assets={assetList}
        searchReport={handleSearchReport}
        handleExportExcel={handleExportExcel}
        handleExportPDF={handleExportPDF}
        errors={filterErrors}
        reportResult={Array.isArray(reportResult) && reportResult.length > 0}
      />
      {Array.isArray(reportResult) && reportResult.length > 0 && (
        <ReportResult reportData={reportResult} />
      )}
    </Structure>
  );
};

const _mapStateToProps = ({ groups }) => {
  return {
    selectedGroups: groups.selectedGroups,
  };
};

export default connect(_mapStateToProps, null)(TrackingBoardReport);
